import React from 'react';
import { IconMissionAgric, IconMissionSurvey } from '../../components/Icons';
import {
	CardGrid,
	CardItem,
} from '../../components/StyledComponents';
import { Page } from '../../components/ui/Page'
import { Body } from '../../components/layout/Body';
import { Label } from '../../components/ui/Label';

import Store from '../../store/Store';

const modes: Record<string, string> = {
	map: 'Standort Suche',
	agric: 'Landwirtschaft',
	survey: 'Vermessung',
	cloud: 'Punktwolken',
	ndvi: 'NDVI',
};

export interface DashboardPageExternProps {
	id?: string;
}

export default function DashboardPageExtern(props: DashboardPageExternProps) {
	const onSelect = async (mode: string) => {
		if (mode === 'map') return Store.navigate('search');

		if (mode === 'agric') {
			await Store.loadSearchOrders('Landwirtschaft');
			Store.navigate('searchOrders');
		} else if (mode === 'survey') {
			await Store.loadSearchOrders('Vermessung');
			Store.navigate('searchOrders');
		}
	};

	return (
		<Page>
			<Body id={props.id}>
				<CardGrid>
					<CardItem onClick={() => onSelect('map')}>
						<h4>{modes['map']}</h4>
					</CardItem>
				</CardGrid>

				<Label>Vorschläge</Label>
				<CardGrid>
					<CardItem onClick={() => onSelect('agric')}>
						<div>
							<IconMissionAgric />
							<h4>{modes['agric']}</h4>
						</div>
					</CardItem>
					<CardItem onClick={() => onSelect('survey')}>
						<div>
							<IconMissionSurvey />
							<h4>{modes['survey']}</h4>
						</div>
					</CardItem>
					<CardItem onClick={() => onSelect('cloud')}>
						<h4>{modes['cloud']}</h4>
					</CardItem>
					<CardItem onClick={() => onSelect('ndvi')}>
						<h4>{modes['ndvi']}</h4>
					</CardItem>
				</CardGrid>
			</Body>
		</Page>
	);
}
